import validator from '@/util/validator.js';
import initCaptcha from '@/util/third-party/netease-captcha.js';
import { _get } from '@/util/string.js';
import { mapActions } from 'vuex';

const accMixin = {
    methods: {
        ...mapActions(['sendVerificationCode'])
    }
};

/**
 * 发送短信验证
 * mobileDataPath： 手机号 对象路径
 * countryCodePath: 区域号 对象路径
 */
const mixin = (mobileDataPath, countryCodePath, classifierPath) => {
    return {
        mixins: [accMixin],
        props: {
            // mobile: {
            //     type: String,
            //     default: ''
            // },
            defaultButText: {
                type: String,
                default: '获取验证码'
            }
        },
        data() {
            return {
                // 滑动块
                captchaIns: null,
                butText: this.defaultButText,
                // 是否disabled
                isVerificationDis: false
            };
        },
        mounted() {
            this.initNeteaseCaptcha();
        },
        methods: {
            initNeteaseCaptcha() {
                // 初始化滑动块
                initCaptcha({
                    element: 'app',
                    callback: res => {
                        this.getVerificationCode({
                            captcha_type: 'netease',
                            captcha_ticket: res.validate
                        });
                    },
                    onClose: () => {
                        console.log('onClose', this.captchaIns);
                        this.captchaIns && this.captchaIns.refresh();
                    }
                }).then(res => {
                    this.captchaIns = res;
                });
            },
            // 获取验证码
            onVerification() {
                const mobile = _get(this, mobileDataPath);
                const countryCode = _get(this, countryCodePath);
                if (!this.isVerificationDis && mobile) {
                    if (!validator[`validateMobile${countryCode}`](mobile)) {
                        this.$message('请正确填写手机号码');
                        return false;
                    }
                    this.getVerificationCode();
                    if (this.campaignCode) {
                        if (
                            this.trackerBindPhone &&
                            typeof this.trackerBindPhone === 'function'
                        ) {
                            this.trackerBindPhone();
                        } else {
                            this.$tracker.bind_phone({
                                requirement_id: 1298,
                                track_sign:
                                    'aCar.b3107.c3121.d3313.result.RetentionFlow',
                                entry: this.$route.query.origin || '未知',
                                ...(this.tracker_common_data || {}),
                                campaign: this.campaignCode
                            });
                        }
                    }
                }
            },
            getVerificationCode(captchaInfo = {}) {
                this.sendVerificationCode(
                    this.getVerificationCodeParams(captchaInfo)
                ).then(res => {
                    if (res.result_code === 'require_captcha') {
                        // 需要进行滑块验证码校验
                        this.captchaIns && this.captchaIns.popUp();
                    } else if (res.result_code === 'frequent_operation') {
                        this.$message('验证码请求过于频繁，请稍后重试');
                    } else if (
                        res.result_code === 'vc_sending_upper_limit_reached'
                    ) {
                        this.$message('短信获取次数已达当日上限');
                    } else if (res.result_code === 'success') {
                        this.countdown();
                    } else {
                        this.$message(res.debug_msg);
                    }
                });
            },
            // 按钮倒计时
            countdown() {
                let time = 60;
                this.isVerificationDis = true;
                this.butText = time + '秒';
                this.intreval = setInterval(() => {
                    time--;
                    this.butText = time + '秒';
                    if (time === 0) {
                        this.countdownClear();
                    }
                }, 1000);
            },
            // 清理倒计时
            countdownClear() {
                this.butText = this.defaultButText;
                this.isVerificationDis = false;
                clearInterval(this.intreval);
            },
            getVerificationCodeParams(params) {
                // 验证码参数
                const mobile = _get(this, mobileDataPath);
                const countryCode = _get(this, countryCodePath);
                const classifier = classifierPath
                    ? _get(this, classifierPath)
                    : 'common_verification';
                return {
                    country_code: countryCode,
                    mobile: mobile,
                    classifier: classifier,
                    remote_ip: window.IP,
                    captcha_type: params.captcha_type || null,
                    captcha_ticket: params.captcha_ticket || null
                };
            }
        }
    };
};
export default mixin;



// WEBPACK FOOTER //
// ./src/mixin/verification.js